import { Col, Input, Radio, Row, Space } from "antd";
import { TypeSizeReportConstants } from "../../types/typesConstants";
import { validateEmail } from "../../helpers/utils";
import { ReportDefaultLayoutUi } from "./ReportDefaultLayoutUi";
import { useEffect, useState } from "react";
import { ModalUi } from "./ModalUi";
import { CloseBtn } from "./Buttons";
import { MailOutlined } from "@ant-design/icons";
import { messageError } from "../../helpers";

export const DocumentPrintModal = ({
  document,
  modalTitle = "Previsualización de documentos",
  open,
  formats = [],
  handlePrintDocument,
  handleCancel,
  showSendEmail = false,
  handleSendEmail,
}) => {
  const { Search } = Input;
  const [filePDF, setFilePDF] = useState(null);
  const [sizeType, setSizeType] = useState(
    formats[0] || TypeSizeReportConstants.R_80,
  );
  useEffect(() => {
    if (document) file_documento(document, sizeType);
  }, [document, sizeType]);

  const handleChangeFormat = (e) => {
    setSizeType(e.target.value);
  };
  const file_documento = async (
    document,
    typesize_report = TypeSizeReportConstants.R_A4,
  ) => {
    let file = null;
    file = await handlePrintDocument(document, typesize_report);
    if (file !== null) {
      const fileURL = URL.createObjectURL(file);
      setFilePDF(fileURL);
    }
  };
  const OnHandleSendEmail = (email_receiver) => {
    const valid = validateEmail(email_receiver);
    if (valid) {
      handleSendEmail(document?.id, email_receiver);
    } else {
      messageError("Ingrese un email válido");
    }
  };

  return (
    <ModalUi
      title={modalTitle}
      centered
      maskClosable={false}
      destroyOnHidden
      open={open}
      onCancel={handleCancel}
      footer={[<CloseBtn key="close" onClick={handleCancel} />]}
      width={{
        xs: "90%",
        sm: "90%",
        md: "80%",
        lg: "70%",
        xl: "70%",
        xxl: "70%",
      }}
    >
      <Row gutter={16} justify="center" style={{ marginBottom: "10px" }}>
        <Col span={24} style={{ textAlign: "center" }}>
          <Space wrap>
            <label>Formato reporte</label>
            <Radio.Group
              value={sizeType}
              buttonStyle="solid"
              onChange={handleChangeFormat}
            >
              {formats.includes(TypeSizeReportConstants.R_80) && (
                <Radio.Button value={TypeSizeReportConstants.R_80}>
                  80 mm
                </Radio.Button>
              )}
              {formats.includes(TypeSizeReportConstants.R_A4) && (
                <Radio.Button value={TypeSizeReportConstants.R_A4}>
                  {TypeSizeReportConstants.R_A4.valueOf()}
                </Radio.Button>
              )}
              {formats.includes(TypeSizeReportConstants.R_A5) && (
                <Radio.Button value={TypeSizeReportConstants.R_A5}>
                  {TypeSizeReportConstants.R_A5.valueOf()}
                </Radio.Button>
              )}
            </Radio.Group>
          </Space>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ height: 600 }}>
          {filePDF && <ReportDefaultLayoutUi fileUrl={filePDF} theme="dark" />}
        </Col>
      </Row>

      {showSendEmail && (
        <Row className="mt-2" justify="center">
          <Col md={16}>
            <Search
              enterButton={
                <>
                  <MailOutlined /> Enviar
                </>
              }
              style={{ width: "90%" }}
              onSearch={OnHandleSendEmail}
            />
          </Col>
        </Row>
      )}
    </ModalUi>
  );
};
